import React from 'react';
import CheckScanner from './CheckScanner';
import { CheckScannerProvider } from './context/CheckScannerContext';

export const CheckScannerWrapper = ({ saveCallback, endorsementContent, ...rest }) => {
  return <CheckScannerProvider value={{ saveCallback }}>
    <CheckScanner endorsementContent={endorsementContent.trim()} {...rest}/>
  </CheckScannerProvider>;
};
